
import Lottie from 'lottie-react';
import Check from '../assets/check.json';
import Button from './Button';

// ?payment_intent=pi_3NOoRCIpgz9cWG3V1ggXzt7t&payment_intent_client_secret=pi_3NOoRCIpgz9cWG3V1ggXzt7t_secret_6QWZj95l0OEjJ0ShZseARwlNj&redirect_status=succeeded

const PaymentSuccessPage = ({ username, setPaidFor }) => {
  return (
    (
      <div className="centered">
        <div className="container narrow-container">
          <div className="username-section">
            <div className="username-box">
              <label>Dear {username},</label>
              <hr />
              <div className="form-fields">
                <h1 style={{ fontSize: '24px' }}>Thank you for your purchase!</h1>
                <div className="lottie-container" style={{ width: '150px', textAlign: 'center', margin: 'auto', }}>
                  <Lottie loop={true} animationData={Check} />
                </div>
                <Button style={{ marginTop: '25px' }} onClick={() => setPaidFor(false)}>Go back</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default PaymentSuccessPage